import { render } from "./TermsConditionsModal.vue?vue&type=template&id=06789def&scoped=true"
import script from "./TermsConditionsModal.vue?vue&type=script&lang=js"
export * from "./TermsConditionsModal.vue?vue&type=script&lang=js"

import "./TermsConditionsModal.vue?vue&type=style&index=0&id=06789def&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06789def"]])

export default __exports__